import React from 'react';

/**
 * Schlanker, unaufdringlicher Lade-Indikator (wie GitHub/YouTube) — zeigt an,
 * dass gerade neu geladen wird, OHNE die bestehenden (noch gueltigen) Daten
 * zu verdecken oder zu ersetzen. Rendert nichts wenn active=false (kein
 * Layout-Sprung durch reservierten Platz).
 */
export default function LoadingBar({ active }) {
  if (!active) return null;
  return <div className="loading-bar" aria-hidden="true"><div className="loading-bar__fill" /></div>;
}
